<script setup lang="ts">
import { PopularProps } from "./Popular.props"
import { customPaths } from "~/utils/constants"

withDefaults(defineProps<PopularProps>(), {
  bgColor: "white"
})
</script>

<template>
  <div
    class="
      wrapper-popular-category
      padded
      flex flex-col
      gap-4
      py-4
      md:gap-6
      md:py-6
    "
    :class="[bgColor === 'white' ? 'bg-white' : 'bg-grey-main']"
  >
    <h3
      class="pig-bold md:hyppo-bold inline-flex flex-wrap items-center gap-1"
      :class="{ 'md:justify-center': isTitleCenter }"
    >
      <span v-if="title">{{ title }}</span>
      <span v-if="category" class="uppercase text-green-main">
        {{ category }}
      </span>
    </h3>

    <div :class="{ 'md:grid-container': isOffetGrid }">
      <div
        class="flex flex-col gap-4 md:flex-row md:gap-6"
        :class="{
          ' md:col-span-10 md:col-start-2 ': isOffetGrid
        }"
      >
        <CardWiki v-for="card in articles" v-bind="card" />
      </div>
    </div>

    <div v-if="path" class="flex justify-center">
      <UtilsButton
        :text="$t('wiki.categories.goToCategory')"
        theme="outlined-green"
        @click="navigateTo(`${customPaths.wikiRoot}/${path}`)"
      />
    </div>
  </div>
</template>
